import { TabsBar } from '@/modules/common/components/tabs-bar';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import {
  $bestMarketPricesTab,
  $bestMarketPricesTabLoading,
  BestPriceBuyerItem,
  getBestMarketPricesFx,
  getBestMarketPricesTabFx,
} from '@/modules/mixing/store/analytical-mixing.store';
import {
  $moistureChangesDensity,
  $selectedRecipeStore,
  $sleeveToView,
  setSleeveToView,
} from '@/modules/mixing/store/recipes.store';
import { useStore } from 'effector-react';
import { useEffect } from 'react';
import { SpecItem } from '../spec-item';
import { SleeveItem } from './components/sleeve-item';
import styles from './index.module.sass';
import { cancelTradeOffer } from '@/modules/mixing/helpers/dalete-offer.helper';
import arrowIcon from '@@/mixing/components/recipes-detail/icons/arrow.svg';
import { DetalisationTooltip } from '@/modules/common/components/detalisation-tooltip';
import { useSearchParams } from 'react-router-dom';
import { fetchWarehousesForMixingDataFx } from '@/widgets/recipe/model';
import { RubleRegular } from '@/modules/common/components/ruble-regular';

export const MainTab = ({
  //selectRecipeFoo,
  tabs,
  activeTab,
  setActiveTab,
}: {
  selectRecipeFoo: (id: number) => void;
  tabs: {
    label: string;
    id: number;
    disabled?: boolean;
  }[];
  activeTab: number;
  setActiveTab: (val: number) => void;
}) => {
  const moistureChangesDensity = useStore($moistureChangesDensity);
  const [searchParams] = useSearchParams();
  const markeredBags = (() => {
    const data = searchParams.get('markered_bags');
    if (data) return data?.split(',');
  })();

  const currentStore = useStore($selectedRecipeStore);
  const sleeveToViewId = useStore($sleeveToView);
  const data = useStore($bestMarketPricesTab)?.find(
    (item) => item.id === currentStore?.id,
  );
  const isStationary = currentStore?.type === '1';
  const loadingStatus = useStore($bestMarketPricesTabLoading);
  const detectBestOfferFoo = function (
    prev: BestPriceBuyerItem,
    current: BestPriceBuyerItem,
  ) {
    return prev.price_per_ton > current.price_per_ton ? prev : current;
  };

  const scrollToItem = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  useEffect(() => {
    getBestMarketPricesTabFx({ trade: true, moistureChangesDensity });
    return () => {};
  }, [currentStore, moistureChangesDensity]);

  useEffect(() => {
    if (data?.bags && data.bags?.length > 0) {
      setTimeout(() => {
        if (markeredBags && Array.isArray(markeredBags)) {
          return scrollToItem(markeredBags[0]);
        }
        if (sleeveToViewId && typeof sleeveToViewId === 'string') {
          return scrollToItem(sleeveToViewId);
        }
      }, 1000);
      return () => {
        setSleeveToView(null);
      };
    }
  }, [data]);

  return (
    <div className={styles.root}>
      <TabsBar tabs={tabs} activeItem={activeTab} setActiveTab={setActiveTab} />
      <div className={styles.specs}>
        <SpecItem
          label="общий вес пшеницы"
          value={
            Number(data?.weight_delta && data?.weight_delta !== 0) ? (
              <>
                {data?.weight.toLocaleString('ru-Ru', { maximumFractionDigits: 1 }) ||
                  0}{' '}
                <RubleRegular customSymbol="т" />{' '}
                <img src={arrowIcon} className={styles.arrowIcon} />{' '}
                {(Number(data?.weight) + Number(data?.weight_delta)).toLocaleString(
                  'ru-Ru',
                  {
                    maximumFractionDigits: 1,
                  },
                ) || 0}{' '}
                <RubleRegular customSymbol="т" />
              </>
            ) : (
              <>
                {data?.weight.toLocaleString('ru-Ru', { maximumFractionDigits: 1 }) ||
                  0}{' '}
                <RubleRegular customSymbol="т" />
              </>
            )
          }
        />
        <SpecItem
          label="стоимость склада"
          value={
            <>
              {data?.price.toLocaleString('ru-Ru', { maximumFractionDigits: 0 }) || 0}{' '}
              <RubleRegular />{' '}
              <DetalisationTooltip infoIcon={true} status="AfterChange" />
            </>
          }
        />
        <SpecItem
          label="cтоимость логистики без миксования"
          value={
            <>
              {data?.unmix_freight.toLocaleString('ru-Ru', {
                maximumFractionDigits: 0,
              }) || 0}{' '}
              <RubleRegular />{' '}
            </>
          }
        />
        {data?.mix_price !== data?.price && (
          <SpecItem
            label="стоимость склада при миксовании"
            value={
              <>
                {data?.mix_price.toLocaleString('ru-Ru', {
                  maximumFractionDigits: 0,
                }) || 0}{' '}
                <RubleRegular />{' '}
              </>
            }
          />
        )}
        <SpecItem
          label="стоимость логистики при миксовании"
          value={
            <>
              {data?.logistic_price.toLocaleString('ru-Ru', {
                maximumFractionDigits: 0,
              }) || 0}{' '}
              <RubleRegular />{' '}
            </>
          }
        />

        <SpecItem
          label="выгода от миксования (НЕТТО)"
          value={
            <span style={{ color: '#007E3C' }}>
              {(data?.mix_profit > 0
                ? data?.mix_profit
                : Math.abs(data?.mix_profit ?? 0)
              ).toLocaleString('ru-Ru', {
                maximumFractionDigits: 0,
              }) || 0}
              <RubleRegular />
            </span>
          }
        />

        {/* <div className={styles.toggler}>
          <span className={styles.label}>учитывать изменение натуры при усушке</span>
          <Switch
            checked={moistureChangesDensity}
            onChange={(val) => setMoistureChangesDensity(val)}
          />
        </div> */}
      </div>
      <div className={styles.contentAreaScrollable} id="contentAreaScrollable">
        {loadingStatus.loading ? (
          <UniversalLoader error={loadingStatus.error} />
        ) : (
          data?.bags &&
          data?.bags.map((item) => {
            if (item.agriculture_id !== 1)
              return (
                <SleeveItem
                  id={item.id}
                  data={item}
                  setActiveTab={setActiveTab}
                  selectedToView={
                    item.id === sleeveToViewId || markeredBags?.includes(item.id)
                  }
                  loading={loadingStatus.loading}
                />
              );
            return (
              <SleeveItem
                id={item.id}
                selectedToView={
                  item.id === sleeveToViewId || markeredBags?.includes(item.id)
                }
                offer={item?.buyers?.reduce(detectBestOfferFoo)}
                loading={loadingStatus.loading}
                data={item}
                setActiveTab={setActiveTab}
                action={
                  // undefined
                  // { type: 'mix', onClick: () => {} }
                  item.trade_id
                    ? {
                        type: 'busy',
                        onClick: () =>
                          cancelTradeOffer(
                            Number(item.trade_id),
                            async () => {
                              await getBestMarketPricesTabFx({
                                trade: true,
                                moistureChangesDensity,
                              });
                              await fetchWarehousesForMixingDataFx({});
                              await getBestMarketPricesFx(true);
                            },
                            isStationary,
                          ),
                      }
                    : item?.buyers?.reduce(detectBestOfferFoo)?.price_all > 0
                    ? { type: 'sell', onClick: () => {} }
                    : item?.mixes && Array.isArray(item.mixes) && item.mixes.length > 0
                    ? { type: 'mix', onClick: () => {} }
                    : undefined
                }
              />
            );
          })
        )}
      </div>
    </div>
  );
};
